import { BOAT_COLUMNS, type Boat } from '../boats';
import { DEFAULT_LOCALE, isSupportedLocale } from '../i18n/locales';
import { setPrefetched } from '../static-prefetch';
import { supabase } from '../supabase';

// Shared by the native and web variants of the app's app/[lang]/boats/[id]. Fetched once
// per export process (not once per locale) — mirrors tour-detail.ts.
let boatsPromise: Promise<Boat[]> | null = null;

/** Every boat, BOAT_COLUMNS only. Memoized; also feeds the boat list seeds (the app's list-prefetch.ts). */
export function fetchAllBoats(): Promise<Boat[]> {
  if (!boatsPromise) {
    boatsPromise = Promise.resolve(supabase.from('boats').select(BOAT_COLUMNS)).then(
      ({ data, error }) => {
        if (error) throw new Error(`generateStaticParams(boats): ${error.message}`);
        return (data ?? []) as Boat[];
      },
    );
  }
  return boatsPromise;
}

// Argument shape: expo-router passes `{ params: parentParams }`, not the
// params directly — see the note in the app's article-detail.ts for what getting this
// wrong cost there. Boats don't vary by locale, so only the returned `lang`
// matters here.
export async function generateBoatStaticParams({
  params,
}: {
  params: { lang?: string };
}): Promise<{ lang: string; id: string }[]> {
  const boats = await fetchAllBoats();
  for (const boat of boats) setPrefetched('boat', boat.id, boat);
  const lang = isSupportedLocale(params.lang) ? params.lang : DEFAULT_LOCALE;
  return boats.map((boat) => ({ lang, id: boat.id }));
}
